module.exports = __webpack_public_path__ + "7a648f8ddba66795b5f4e7b42a36a85a.png";